<template>
  <div class="list-item">
    <div class="list-item-title text-ellipsis" :title="notice.title">
      <el-checkbox
        v-if="useCheckbox"
        :value="localChecked"
        class="m-r-8"
        @change="handleCheckChange"
      />

      <div v-if="showVipTag" class="title-label vip-label">VIP</div>

      <span style="vertical-align: middle" @click="handleTitleClick">
        {{ notice.title || '-' }}
      </span>
    </div>
    <div class="list-item-info">
      <div class="list-item-tags">
        <div v-if="notice.province" class="tag tag--primary">
          {{ notice.province }}
        </div>
        <div v-if="notice.bidMethod" class="tag tag--warning">
          {{ notice.bidMethod | bidMethodFilter }}
        </div>
        <div v-if="notice.budget" class="tag tag--danger">
          {{ notice.budget | moneyFilter }}万
        </div>
        <div v-if="notice.noticeType" class="tag tag--success">
          {{ notice.noticeType | noticeTypeFilter }}
        </div>
        <div v-if="notice.categoryName" class="tag categories">
          {{ notice.categoryName }}
        </div>
      </div>
      <div class="list-item-time">
        {{ timeFilter(notice.publishTime) }}
      </div>
    </div>
  </div>
</template>

<script>
// 字典
import { bidMethodDict } from '@/dictionary/bid'
import { noticeResourceDict, noticeTypeDict } from '@/dictionary/common'
// 工具
import { strToThousands, toPortalNotice } from '@/utils/common'
import moment from 'moment'
// vuex
import { mapState } from 'vuex'

export default {
  name: 'NoticeListItem',

  filters: {
    bidMethodFilter(value) {
      return bidMethodDict.translate(value)?.label || '-'
    },

    moneyFilter(value) {
      return strToThousands(value)
    },

    noticeTypeFilter(value) {
      return noticeTypeDict.transitionTo(value)?.label || '-'
    }
  },

  props: {
    notice: {
      type: Object,
      default: () => {}
    },

    useCheckbox: {
      type: Boolean,
      default: false
    },

    checked: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('system', ['systemTime']),

    localChecked: {
      get() {
        return this.checked
      },
      set(val) {
        this.$emit('update:checked', val)
      }
    },

    showVipTag() {
      return this.notice.resource !== noticeResourceDict.JCZH.value.toString()
    }
  },
  methods: {
    timeFilter(value) {
      const now = moment(this.systemTime)
      const start = moment(value)
      // 小时
      const hours = now.diff(start, 'hours')
      return hours < 24 ? hours + '小时前' : value
    },

    handleTitleClick() {
      this.$emit('clickTitle')
      if (this.notice.resource === noticeResourceDict.JCZH.value.toString()) {
        if (this.notice.url) {
          toPortalNotice({ noticeUrl: this.notice.url })
          return
        }
        // 站内公告，直接前往门户相应的公告页
        toPortalNotice({ noticeId: this.notice.noticeId })
      } else {
        // 站外公告，则前往标前狗的公告页
        this.$router.push({
          name: 'NoticeDetail',
          params: { noticeId: this.notice.noticeId }
        })
      }
    },

    handleCheckChange(val) {
      this.localChecked = val
      this.$emit('changeCheck')
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: 16px 0;
  border-bottom: 1px solid $info-fourth-color;

  .list-item-title {
    display: inline-block;
    font-size: 16px;
    margin-bottom: 12px;
    max-width: 80%;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }

    .title-label {
      display: inline-block;
      height: 20px;
      width: 32px;
      text-align: center;
      border-radius: 4px;
      margin-right: 6px;
      vertical-align: middle;
    }

    .free-label {
      font-size: 12px;
      line-height: 1.6;
      color: #fff;
      background: $primary-color;
    }
    .vip-label {
      font-size: 14px;
      line-height: 1.4;
      color: $member-second-color;
      background: $member-sixth-color;
    }
  }

  .list-item-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .list-item-tags {
    .tag {
      display: inline-block;
      padding: 4px 8px;
      border-radius: 2px;
      font-size: 12px;

      &:not(:last-child) {
        margin-right: 8px;
      }

      &--primary {
        color: $primary-color;
        background-color: $primary-fourth-color;
      }

      &--warning {
        color: $warning-color;
        background-color: $warning-third-color;
      }

      &--danger {
        color: $danger-color;
        background-color: $danger-third-color;
      }
    }
    .categories {
      background: #f8edff;
      color: #945fb9;
    }
  }

  .list-item-time {
    font-size: 12px;
    color: $text-third-color;
  }
}
</style>
